import { CaseState } from 'app/area/case/types-store';
import { ConnectedComponentProps } from 'app/infrastructure/ui/types-uischema';
import { CaseListingStoreState } from 'app/area/case-report/case-listing/types-store';
import { SharedState } from 'app/types-shared';
import { mapSharedState } from 'app/infrastructure/redux';

export const sharedState = 
  (state: CaseState | CaseListingStoreState, uiEngineProps: ConnectedComponentProps, applicationState: any):
    { sharedState: SharedState } => {
    return { sharedState: mapSharedState(applicationState) };
  };
